import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from '../routeConfig';
import PageAccessGuard from './PageAccessGuard';

interface AppRoutesProps {
    /**
     * Turn away a page the user's category does not list. Off only in the permissions preview,
     * which is shown to an administrator and must show the page whatever its own settings say.
     */
    guarded: boolean;
}

const AppRoutes = ({ guarded }: AppRoutesProps) => (
    <Routes>
        {routes.map(route => (
            <Route
                key={route.path}
                path={route.path}
                element={
                    guarded ? <PageAccessGuard>{route.element}</PageAccessGuard> : route.element
                }
            />
        ))}
        <Route path="*" element={<Navigate to="/" />} />
    </Routes>
);

export default AppRoutes;
